<template>
  <q-layout view="lHh Lpr lFf">
    <q-header class="bg-black">
      <q-toolbar class="app--toolbar">
        <q-img class="title-image" src="/images/website_title.svg" />
        <q-space />
        <q-btn v-if="mobile" flat icon="menu">
          <q-menu>
            <q-list style="min-width: 100pt">
              <q-item clickable @click="onPage('/')">
                <q-item-section>Home</q-item-section>
              </q-item>
              <q-item clickable @click="onPage('/help')">
                <q-item-section>Help</q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </q-btn>
        <q-tabs v-else style="align-self:stretch" v-model="tab">
          <q-route-tab name="home" label="Home" to="/" exact></q-route-tab>
          <q-route-tab name="faq" label="Help" to="/help" exact></q-route-tab>
        </q-tabs>
      </q-toolbar>
    </q-header>

    <q-page-container>
      <router-view />
    </q-page-container>
  </q-layout>
</template>

<script>
import "@/styles/global.scss";
import { model, Device } from "@/model/Model";

export default {
  name: "LayoutDefault",

  components: {},

  data() {
    return {
      tab: "home",
    };
  },

  computed: {
    mobile() {
      return model.device == Device.SMALL;
    },
  },

  methods: {
    onPage(page) {
      this.$router.push(page);
    },
  },
};
</script>

<style scoped>
.title-image {
  width: 150pt;
  margin: 10pt;
}

.app--toolbar {
  border-bottom: 1px solid #2a2a2a;
  box-shadow: 0px 0px 20px 5px #000000;
}
</style>
